angular.module('wbDashboard').controller('OverviewSummaryPlanControllerAurea',
    ['$scope', 'User', 'Milestone', 'FormulaService', 'PlanningService',
function ($scope, User, Milestone, FormulaService, PlanningService) {

    $scope.FS = FormulaService;

    $scope.$watch(function() { return [FormulaService.user.getFormulas(), FormulaService.user.getWallet(), User.getWalletMS()]; }, function(data) {
        var [formulas, wallet, walletMS] = data;
        if (formulas && wallet) {
            $scope.formulas = formulas;
            $scope.wallet = wallet;
            $scope.walletMS = walletMS;
        }
    }, true);

    // to determine if there are any milestone recommendations
    $scope.$watch(function() { return PlanningService.getRecommendations(); }, function(recommendations) {
        $scope.recommendedMilestones = [];
        if (recommendations) {
            recommendations.forEach(function(r) {
                var ms = {};
                if (r.action === 'new_milestone') {
                    ms.name = Milestone.views[r.action_type].name;
                    ms.type = r.action_type;
                    switch (r.action_type) {
                        case 'retirement':
                            ms.estDate = moment($scope.overview.user.birth_date).add(70, "years").toDate();
                            break;
                        case 'new_home':
                            ms.estDate = moment().add(12*5, "months").toDate();
                            break;
                        case 'rainy_day':
                            ms.estDate = moment().add(18, "months").toDate();
                            break;
                        default:
                            return;
                    }
                    $scope.recommendedMilestones.push(ms);
                }
            });
        }
    }, true);



}]);
